import { Stack } from '@mui/material'
import { IssuedTickets } from '../models'
import { Typography } from '@mui/material'
import { customFormatLocalDate } from 'src/admin/core/services/dateFunctions'

export const FinalTransaction = ({ticket}: {ticket: IssuedTickets}) => {
    const finalTransaction = ticket?.finalTransaction

    return (
        finalTransaction && (
            <Stack
                direction="column"
                alignItems="flex-start"
                alignContent="flex-start"
            >
                <Typography variant="body2">
                    {`${finalTransaction?.agency.name} | ${finalTransaction?.workstation.name} | ${customFormatLocalDate(finalTransaction?.date)}`}
                </Typography>

            </Stack>
        )
    )
}